/** L7: the codex (ทะเบียนสัตว์ร้าย) section of the วันนี้ panel: kills per family and the next tier. Reads state only. */
import { CODEX_FAMILIES, CODEX_TIERS, type World } from '@nine/shared';
import { h } from './dom';

export function codexRows(w: World): HTMLElement[] {
  const c = w.progress.codex;
  const seen = CODEX_FAMILIES.filter((f) => (c?.n[f.id] ?? 0) > 0);
  if (!seen.length) return [h('h4', {}, 'ทะเบียนสัตว์ร้าย'), h('ul', {}, h('li', {}, 'ยังไม่เคยปราบสัตว์ร้าย'))];
  const lines = seen.map((f) => {
    const n = c!.n[f.id];
    const t = c!.tier[f.id] ?? 0;
    const next = CODEX_TIERS[t];
    const bonus = t > 0 ? ` · ดาเมจ +${Math.round(CODEX_TIERS[t - 1].dmg * 100)}%` : '';
    return h('li', {}, `${f.name} ${n}${next ? `/${next.kills}` : ' (ครบ)'}${bonus}`);
  });
  return [h('h4', {}, 'ทะเบียนสัตว์ร้าย'), h('ul', {}, ...lines)];
}
